var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      value: _vm.value,
      options: _vm.options,
      label: "text",
      reduce: (item) => item.value,
      disabled: _vm.disabled,
      required: _vm.required,
      placeholder: _vm.placeholder,
      loading: _vm.loading,
    },
    on: { input: _vm.onInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }